<style>
@import '../../custom/css/aprovadas.css';
</style>

<template>
  <div class="aprovadas" id="inicio">
    <div class="row m-0">
      <div class="col-12 my-4">
        <h1
          class="title font-weight-bold text-uppercase"
        >
          {{
            cotacoes.length > 0
              ? 'Pedidos Aprovados'
              : 'Sem Pedidos Aprovados'
          }}
        </h1>
      </div>
      <div
        class="col-lg-4 col-md-6"
        v-for="(cotacao, index) in cotacoes"
        :key="index"
      >
        <div class="card-cotacao">
          <div class="cc-header d-flex">
            <div class="cc-sub-title m-r-25">
              <img
                class="imagem-archive-cotacao"
                src="@/assets/img/icons/file-archive.png"
                alt="Ícone para representar a cotação"
              />
            </div>
            <div class="cc-sub-title">
              <div>
                Data:
                <div class="cc-sub-result">{{ cotacao.atualizado_em }}</div>
              </div>
              <div>
                Cód:
                <div class="cc-sub-result">{{ cotacao.cot_cotacao_id }}</div>
              </div>
            </div>
          </div>
          <div class="cc-footer">
            <span class="btn-ver-cotacao heigth " @click="verCotacao(cotacao.id)">
              Ver pedido
            </span>
          </div>
          <div class="cc-footer">
            <span>
              <input class="borda" type="text" :id="cotacao.id" placeholder="Token para entrega" maxlength="6">
              <span class="sendToken" @click="sendToken(cotacao.id)">Ok</span>
              <span class="alertToken">
                <i class="fas fa-question-circle question-tool-tips" id="tokenUp"></i>
                <b-tooltip target="tokenUp">
                  Solicite ao cliente o token que confirmará a entrega dos produtos e daremos andamento ao recebimento do pagamento do atual pedido.
                </b-tooltip>
              </span>
            </span>
          </div>
          <div class="row">
            <span class="entregarPedido">
              Entregar até: {{ cotacao.data_entrega }}
                <i class="fas fa-question-circle question-tool-tips" id="aprovarUp"></i>
                <b-tooltip target="aprovarUp">
                  A não entrega dos itens até a data limite, 
                  será cancelado o pedido e cobrado uma multa de {{ cotacao.taxa_cancelamento_sem_mascara > 99 ? cotacao.taxa_cancelamento : 'R$ 1,00'}}.
                </b-tooltip>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import scrollToElement from '../../mixins/scrollToElement';
import makeToast from '../../mixins/makeToast';

export default {
  mixins:[scrollToElement, makeToast],
  name: 'aprovadas',
  data() {
    return {
      sendTokenClient: ''
    }
  },
  computed: {
    ...mapGetters([
      // Mapeamento de getters
    ]),
    ...mapState({
      // Mapeamento de states
      token: (state) => state.token,
      dadosUsuario: (state) => state.dadosUsuario,
      cotacoes: (state) => state.cotacoes,
    }),
  },
  mounted(){
    this.scrollToElement();
  },
  created() {
    this.scrollToElement();
    const self = this;

    if (this.checkIsEmpty(this.dadosUsuario)) {
      this.$router.push({ name: 'area-restrita' });
    }

    this.$store.dispatch('emptyCotacoes').then(() => {
      this.$store.dispatch('startLoader');
      setTimeout(() => {
        self.$store
          .dispatch('showCotacoesUsuarioAprovadasVendas', this.dadosUsuario.id)
          .then(() => {
            setTimeout(() => {
              self.$store.dispatch('endLoader');
            }, 1000);
          })
          .catch(() => {
            setTimeout(() => {
              self.$store
                .dispatch(
                  'showCotacoesUsuarioAprovadasVendas',
                  this.dadosUsuario.id
                )
                .then(() => {
                  setTimeout(() => {
                    self.$store.dispatch('endLoader');
                  }, 1000);
                })
                .catch(() => {
                  self.$store.dispatch('endLoader');
                  self.aviso(
                    'Não foi possível carregar as cotações! Tente novamente em 5 minutos!',
                    'danger'
                  );
                });
            }, 1000);
          });
      }, 1000);
    });
  },
  methods: {
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    verCotacao(value) {
      if (!this.checkIsEmpty(value)) {
        this.$router.push({
          name: 'lojista-cotacao-ganha',
          params: { id: value },
        });
      }
    },
    sendToken(id) {
      this.$store.dispatch('startLoader');
      const data = {
        'id': id,
        'token': document.getElementById(id).value
      }
      if(data.id === "" || data.token.length <= 5) {
        this.makeToast('Erro', 'Verifique se o token está inserido com os 6 dígitos.', 'danger');
        return;
      }
      this.$store
        .dispatch('sendTokenValidQuote',data)
        .then((response) => {
          if(response.data.error === true){
            this.makeToast('Erro', 'Token invalido','danger');
          }
          if(response.data.error === false) {
            this.makeToast('Sucesso', 'Recebimento do pedido confirmado com sucesso!','success');
            setTimeout(() => {
              this.$router.push({ name: 'lojista-completas' });
            }, 1000);
          }
          this.$store.dispatch('endLoader');
        })
        .catch(() => {
          this.makeToast('Erro', 'Não foi salvar o seu token para confirmação de pagamento!','danger');
          this.$store.dispatch('endLoader');
        });
    }
  },
};
</script>
<style scoped>
.borda {
  width: 87%;
  border-radius: 5px;
  text-align: center;
  border: 1px solid black;
}
.sendToken {
  width: 13%;
  border: 1px solid #000;
  padding: 1px 7px;
  background-color: #ee670c;
  color: #fff;
  border-radius: 4px;
  position: absolute;
  text-align: center;
  right: 10%;
  cursor: pointer;
}
.heigth{
  padding: 10px;
}
.entregarPedido {
  width: 100%;
  padding: 0 0 2px 0;
  color: rgb(233, 10, 10);
  font-size: 13px;
  text-align: center;
}
.alertToken {
  position: absolute;
  right: 20px;
  bottom: 60px;
}
</style>
